export default __webpack_public_path__ + "static/media/imgevent-min.c963f6c7.jpg";